import { type Cache } from "swr";

const instance: Cache = new Map();
/** using singleton pattern so we can get hold of app cache from any where in the app */
export const getCache = (): Cache => instance;

export default getCache;
